import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "deposit-btn-container" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TooltipHover = _resolveComponent("TooltipHover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TooltipHover, { fit: true }, {
      root: _withCtx(() => [
        _createElementVNode("div", {
          class: "deposit-btn",
          style: _normalizeStyle({ width: _ctx.dim, height: _ctx.dim, 'border-radius': _ctx.borderRadius }),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDeposit && _ctx.openDeposit(...args)))
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("svg", {
            width: "10",
            height: "10",
            viewBox: "0 0 10 10",
            fill: "none",
            class: "btn-icon"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M4.99988 0.624969C5.40259 0.624969 5.72904 0.951429 5.72904 1.35414V4.2708H8.64571C9.04842 4.2708 9.37488 4.59726 9.37488 4.99997C9.37488 5.40268 9.04842 5.72914 8.64571 5.72914H5.72904V8.6458C5.72904 9.04851 5.40259 9.37497 4.99988 9.37497C4.59717 9.37497 4.27071 9.04851 4.27071 8.6458V5.72914H1.35404C0.951337 5.72914 0.624878 5.40268 0.624878 4.99997C0.624878 4.59726 0.951337 4.2708 1.35404 4.2708H4.27071V1.35414C4.27071 0.951429 4.59717 0.624969 4.99988 0.624969Z",
              fill: "currentColor"
            })
          ], -1)
        ]))], 4)
      ]),
      text: _withCtx(() => [
        _createElementVNode("span", {
          innerHTML: _ctx.t('DepositBtn.title')
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    })
  ]))
}